//Componentes generales
import { useContext, useEffect, useState } from "react";
import clienteAxios from "../../config/axios";
import "bootstrap/dist/css/bootstrap.min.css";
import Select from "react-select";
import InputMask from "react-input-mask";

//Estilos
import "./FormUser.css";

// Alertas
import Swal from "sweetalert2";

// Contexts
import proveedoresContext from "../../context/proveedores/proveedoresContext.js";

// Rol PROV
import { PROV } from "../../utils/roles.js";

/*
    Componente encargado de mostrar el formulario de usuario.
        Donde data es el usuario crear/modificar.
              minimizar es la función encargada de ocultar el dialogo.
              generar es la función del context que guarda el usuario.
              titulo es la que determina que texto mostrar en encabezado del dialogo.
              verficaUser es la función del context que comprueba la licencia por usuario vigente del cliente.
*/
function FormUser({
  data = undefined,
  minimizar,
  generar,
  titulo,
  verificaUser,
  listGroups,
  uSession,
}) {
  //State de usuario. Si no viene data por parametro significa que es nuevo por lo que se le asigna una estructura.
  const [user, setUser] = useState(
    data !== undefined
      ? data
      : {
          nroCta: "",
          userName: "",
          fullName: "",
          password: "",
          email: "",
          enabled: false,
          userType: [{ _id: "", typeName: "", descr: "" }],
          gruposAsignaComp: [],
        }
  );
  //State para errores. Valida que los datos ingresados por el usuario sean correctos.
  const [error, setError] = useState({
    userName: false,
    fullName: false,
    email: false,
    password: false,
    userType: false,
    msg: "",
  });

  //Constante que define el titulo que corresponde si vienen datos por parametros
  const tituloBoton = data === undefined ? "Agregar" : "Modificar";

  //State para items. En este contexto, llamamos items a los roles que puede poseer un usuario.
  const [items, setItems] = useState([]);
  //State para grupos. En este contexto, llamamos grupos a los grupos que puede poseer un usuario.
  const [groups, setGroups] = useState([]);
  //State que determina si el usuario tiene licencias.
  const [controlUsuarios, setControlUsuarios] = useState(false);
  //State que determina el rol del usuario seleccionado.
  const [selectedOptions, setSelectedOptions] = useState(
    user.userType.length > 0 && user.userType[0]._id !== ""
      ? {
          value: user.userType[0].typeName,
          label: user.userType[0].descr,
        }
      : null
  );
  const [selectedProveedor, setSelectedProveedor] = useState({});
  const [isRolProv, setIsRolProv] = useState(false);
  const [selectedGroupOptions, setGroupSelectedOptions] = useState([]);
  const [permisosRegistroTdoc, setPermisosRegistroTdoc] = useState({
    notRestrictions:
      data?.permissionRegTdoc?.notRestrictions ?? false,
    allowInvalidNroCodOri:
      data?.permissionRegTdoc?.allowInvalidNroCodOri ?? false,
    allowInvalidDateOfIssue:
      data?.permissionRegTdoc?.allowInvalidDateOfIssue ?? false,
    allowOldDateOfIssue:
      data?.permissionRegTdoc?.allowOldDateOfIssue ?? false,
  });

  const provContext = useContext(proveedoresContext);
  const { proveedores, actualizarProveedores } = provContext;

  /* 
        Al renderizar el componente, setea los roles disponibles.
                                     setea la posibilidad de habilitar el usuario segun las licencias que posee. Si tiene usadas todas sus licencias, permite crear el usuario mas no permite habilitarlo.
    */
  useEffect(() => {
    //Actualiza la Lista de roles y proveedores disponibles.
    const actualizar = async () => {
      const resp = await clienteAxios.get(`/userType`);
      let items = new Array();

      resp.data.data.map((type) => {
        items.push({
          _id: type._id,
          typeName: type.typeName,
          descr: type.descr,
        });
      });

      if (user.userName !== "") {
        const resp2 = await clienteAxios.get(
          `/grupoUsuarios/complete?guUserID=${user._id}`
        );
        let items2 = new Array();

        resp2.data.data.map((type) => {
          items2.push({ _id: type.grupo._id, name: type.grupo.name });
        });

        //Recorrer gruposAsignaComp para recuperar de cada grupo en ListGroup el objeto completo y luego crear el arreglo options
        if (user.gruposAsignaComp && listGroups && listGroups.length > 0) {
          const listGroupsUser = user.gruposAsignaComp.map((idGroup) => {
            const group = listGroups.find((lg) => lg._id === idGroup);
            return group;
          });

          const items3 = listGroupsUser.map((g) => ({
            _id: g._id,
            name: g.name,
          }));

          //Setea Asignación de grupos a comprobantes
          setGroupSelectedOptions(items3);
        }

        setGroups(items2);
      }
      setItems(items);
      await actualizarProveedores();
    };
    actualizar();

    //Recupera usuarios habilitados y seteo state de control.
    const verificar = async () => {
      const licenciaUsuario = await verificaUser();
      if (user.enabled) {
        setControlUsuarios(false);
      } else {
        if (
          licenciaUsuario.data.userEnabled ===
          licenciaUsuario.data.maxUsersEnabled
        ) {
          setControlUsuarios(true);
        } else {
          setControlUsuarios(false);
        }
      }
    };
    verificar();
  }, []);

  /*
        Función que muestra un pop it alerta de tipo advertencia.
            Donde mensaje es lo que queremos que diga la alerta.
    */
  const alerta = (mensaje) => {
    Swal.fire({
      text: mensaje,
      icon: "warning",
      confirmButtonText: "OK",
    });
  };

  function formatCUIT(cuit) {
    cuit = cuit.toString();

    const parte1 = cuit.slice(0, 2);
    const parte2 = cuit.slice(2, -1);
    const parte3 = cuit.slice(-1);

    return `${parte1}-${parte2}-${parte3}`;
  }

  /* 
        Manejador de selección de roles de usuario.
            Donde selected son todos los roles seleccionado. 
    */
  const handleSelectRolChange = (selected) => {
    const tieneRolProv = selected?.value === PROV;
    setIsRolProv(tieneRolProv);
    if (!tieneRolProv && selected.length !== 0) {
      setSelectedProveedor({});
    }
    if (!data) {
      const rolAnterior = selectedOptions?.value;
      if (
        (rolAnterior === PROV && !tieneRolProv) || // De PROV a otro rol
        (rolAnterior !== PROV && tieneRolProv) // De otro rol a PROV
      ) {
        // Resetea los campos cuando cambia de PROV a otro rol o viceversa
        setUser((prevState) => ({
          ...prevState,
          nroCta: "",
          userName: "",
          fullName: "",
          email: "",
          enabled: false,
          password: "",
        }));
        setGroupSelectedOptions([]); // Limpia los grupos asignados
      }
    }

    setSelectedOptions(selected);

    const filteredItem = items.find((obj) => obj.typeName === selected.value);

    setUser((prevState) => ({
      ...prevState,
      userType: filteredItem ? [filteredItem] : [],
    }));
  };

  /* 
        Manejador de selección de proveedor.
            Donde selected es el proveedor seleccionado. 
    */
  const handleSelectProvChange = (selected) => {
    setUser((prevState) => ({
      ...prevState,
      nroCta: "",
      userName: "",
      fullName: "",
      email: "",
    }));
    setSelectedProveedor(selected);

    const cuitFormateado = formatCUIT(selected.value.cuit);

    setUser(prevUser => ({
      ...prevUser,
      nroCta: selected.value.nroCta,
      userName: cuitFormateado,
      fullName: selected.value.nombre,
      email: selected.value.direml,
    }));
  };

  /* 
        Manejador de selección de Asignación de grupos a comprobantes del usuario.
            Donde selected son todos los grupos seleccionado. 
    */
  const handleSelectGroupChange = (selected) => {
    console.log(selected);
    setGroupSelectedOptions(
      selected.map((i) => ({ _id: i.value, name: i.label }))
    );
    const filteredArray = selected.map((i) => i.value);
    setUser(prevUser => ({ ...prevUser, gruposAsignaComp: filteredArray }));
  };

  /*
    const handleRolesUsuario = (rol,check) =>{
        if(check){
            const nuevoArregloRoles = [...user.userType.filter((d) => d._id !== ''), rol];
            setUser({ ...user, userType: nuevoArregloRoles});
        }else{
            const nuevoArregloRoles = [...user.userType.filter((d) => d._id !== rol._id)];
            setUser({ ...user, userType: nuevoArregloRoles});
        }
    }*/

  const verificar = async () => {
    let isGenerable = true;
    let errors = {
      userName: false,
      fullName: false,
      email: false,
      password: false,
      permissionRegTdoc: false,
      userType: [],
      msg: "",
    };

    //Verificaciones
    if (data === undefined) {
      if (user.userName === "") {
        errors.userName = true;
        errors.msg = "No ingresó un usuario para el proveedor";
      } else if (isRolProv) {
        if (
          !selectedProveedor?.value?.cuit &&
          !selectedProveedor?.value?.nroCta
        ) {
          errors.userName = true;
          errors.msg =
            "Debe seleccionar un proveedor de la lista de proveedores";
        }
      }
      try {
        const resp = await clienteAxios.get(
          `/user/usersByNroCtaAndUserName/nroCta/${user.nroCta}/userName/${user.userName}`
        );

        if (resp.data.data.length > 0) {
          errors.userName = true;
          errors.msg = "El usuario que está intentando crear ya existente";
        }
      } catch (error) {}
    }
    if (user.fullName === "") {
      errors.fullName = true;
      errors.msg = "No ingresó un nombre";
    }
    if (user.password === "" && data === undefined) {
      errors.password = true;
      errors.msg = "No ingresó una contraseña";
    }
    if (user.userType.length < 1) {
      errors.userType = true;
      errors.msg = "Tipo de usuario no válido";
    }
    if (
      permisosRegistroTdoc.notRestrictions === true &&
      permisosRegistroTdoc.allowInvalidNroCodOri === false &&
      permisosRegistroTdoc.allowInvalidDateOfIssue === false &&
      permisosRegistroTdoc.allowOldDateOfIssue === false
    ) {
      errors.permissionRegTdoc = true;
      errors.msg = "Debe tildar uno o más permisos de registro de comprobante";
    }

    setError(errors);

    const hasErrors =
      errors.userName ||
      errors.fullName ||
      errors.email ||
      errors.password ||
      errors.permissionRegTdoc;

    if (hasErrors) {
      alerta(errors.msg);
      return false;
    }

    return true;
  };

  const handlerGenerar = async () => {
    const esValido = await verificar();

    if (!esValido) return;

    const userToSave = {
      ...user,
      permissionRegTdoc: permisosRegistroTdoc,
    };

    generar(userToSave, data === undefined ? 0 : 1);
  };

  return (
    <div className="container-gr-form">
      <div className="title-form">{titulo}</div>
      <div className="container-form">
        <div className="label-form">Rol: </div>
        <div className="container-checkbox">
          <Select
            styles={{
              multiValueLabel: (base) => ({
                ...base,
                backgroundColor: "#00D4E2",
                color: "white",
                borderRadius: "none",
                fontSize: "1rem",
              }),
              multiValueRemove: (base) => ({
                ...base,
                backgroundColor: "#00D4E2",
                color: "white",
                borderRadius: "none",
                fontSize: "1rem",
              }),
            }}
            placeholder=""
            options={
              items && items.length > 0
                ? (data
                    ? items.filter(
                        (item) =>
                          data?.userType?.[0]?.typeName === PROV ||
                          item.typeName !== PROV
                      ) // Filtra solo si hay data
                    : items
                  ) // Si no hay data, no se filtra nada
                    .map((item) => ({
                      value: item.typeName,
                      label: item.descr,
                    }))
                : []
            }
            value={selectedOptions}
            onChange={handleSelectRolChange}
            isDisabled={data?.userType?.[0]?.typeName === PROV}
            menuIsOpen={
              data?.userType?.[0]?.typeName === PROV ? false : undefined
            }
          />
        </div>
      </div>
      {isRolProv && (
        <div className="container-form">
          <div className="label-form">Proveedor: </div>
          <div className="container-checkbox">
            <Select
              styles={{
                multiValueLabel: (base) => ({
                  ...base,
                  backgroundColor: "#00D4E2",
                  color: "white",
                  borderRadius: "none",
                  fontSize: "1rem",
                }),
                multiValueRemove: (base) => ({
                  ...base,
                  backgroundColor: "#00D4E2",
                  color: "white",
                  borderRadius: "none",
                  fontSize: "1rem",
                }),
                menuList: (base) => ({
                  ...base,
                  maxHeight: "20vh",
                  overflowY: "auto",
                }),
              }}
              placeholder=""
              options={
                proveedores && proveedores.length > 0
                  ? proveedores.map(function (prov) {
                      return {
                        value: prov,
                        label: prov.nroCta + " - " + prov.nombre,
                      };
                    })
                  : []
              }
              value={selectedProveedor}
              onChange={handleSelectProvChange}
            />
          </div>
        </div>
      )}
      <div className="container-form">
        <div className="label-form">Usuario: </div>
        <div>
          {isRolProv ? (
            <InputMask
              mask="99-99999999-9"
              maskChar=""
              value={user.userName}
              readOnly={true}
              onChange={(e) => {
                const value = e.target.value.replace(/\D/g, ""); // solo dígitos
                setUser(prevUser => ({ ...prevUser, userName: e.target.value }));
              }}
            >
              {(inputProps) => (
                <input
                  {...inputProps}
                  type="text"
                  className="label-form-data"
                  inputMode="numeric"
                  pattern="[0-9]*"
                />
              )}
            </InputMask>
          ) : (
            <input
              readOnly={data}
              value={user.userName}
              className="label-form-data"
              onChange={(data) =>
                setUser(prevUser => ({ ...prevUser, userName: data.target.value }))
              }
            ></input>
          )}
        </div>
      </div>
      <div className="container-form">
        <div className="label-form">Nombre: </div>
        <div>
          <input
            readOnly={selectedOptions?.value == PROV}
            value={user.fullName}
            className="label-form-data"
            onChange={(data) =>
              setUser(prevUser => ({ ...prevUser, fullName: data.target.value }))
            }
          ></input>
        </div>
      </div>
      <div className="container-form">
        <div className="label-form">Email: </div>
        <div>
          <input
            readOnly={selectedOptions?.value == PROV}
            value={user.email}
            className="label-form-data"
            onChange={(data) => setUser(prevUser => ({ ...prevUser, email: data.target.value }))}
          ></input>
        </div>
      </div>
      <div className="container-form">
        <div className="label-form">Nueva Clave: </div>
        <div>
          <input
            type="password"
            value={user.password}
            className="label-form-data"
            onChange={(data) =>
              setUser(prevUser => ({ ...prevUser, password: data.target.value }))
            }
          ></input>
        </div>
      </div>
      <div className="container-form">
        <div className="label-form">Habilitado: </div>
        {!controlUsuarios && (
          <div>
            <input
              type="checkbox"
              checked={user.enabled}
              className="label-form-check-data"
              onChange={(data) =>
                setUser(prevUser => ({ ...prevUser, enabled: data.target.checked }))
              }
            ></input>
          </div>
        )}
        {controlUsuarios && (
          <div>
            <input
              type="checkbox"
              className="label-form-check-data"
              disabled
            ></input>
          </div>
        )}
      </div>

      <div className="container-form" style={{ marginBottom: "15px" }}>
        <div className="permisos-header">
          <div className="label-form">
            Permisos especiales en registro de comprobante:
          </div>

          <div style={{ marginTop: "8px" }}>
            <input
              type="checkbox"
              checked={permisosRegistroTdoc.notRestrictions}
              className="check-permisos"
              onChange={(e) =>
                setPermisosRegistroTdoc((prev) => ({
                  ...prev,
                  notRestrictions: e.target.checked,
                  ...(e.target.checked === false && {
                    allowInvalidNroCodOri: false,
                    allowInvalidDateOfIssue: false,
                    allowOldDateOfIssue: false,
                  }),
                }))
              }
            />
          </div>
        </div>
        <small className="text-muted">
          El comprobante se guardá con marca de OBSERVADO
        </small>

        <div>
          {permisosRegistroTdoc.notRestrictions && (
            <div style={{ marginLeft: "40px", marginTop: "8px" }}>
              <label>
                <input
                  type="checkbox"
                  checked={permisosRegistroTdoc.allowInvalidNroCodOri}
                  onChange={(e) =>
                    setPermisosRegistroTdoc((prev) => ({
                      ...prev,
                      allowInvalidNroCodOri: e.target.checked,
                    }))
                  }
                />{" "}
                <strong>
                  <em>Número de Comprobante</em>
                </strong>{" "}
                no leído por IA en el adjunto
              </label>
              <br />
              <label>
                <input
                  type="checkbox"
                  checked={permisosRegistroTdoc.allowInvalidDateOfIssue}
                  onChange={(e) =>
                    setPermisosRegistroTdoc((prev) => ({
                      ...prev,
                      allowInvalidDateOfIssue: e.target.checked,
                    }))
                  }
                />{" "}
                <strong>
                  <em>Fecha de emisión</em>
                </strong>{" "}
                no leída por IA en el adjunto
              </label>
              <br />
              <label>
                <input
                  type="checkbox"
                  checked={permisosRegistroTdoc.allowOldDateOfIssue}
                  onChange={(e) =>
                    setPermisosRegistroTdoc((prev) => ({
                      ...prev,
                      allowOldDateOfIssue: e.target.checked,
                    }))
                  }
                />{" "}
                <strong>
                  <em>Fecha de emisión</em>
                </strong>{" "}
                con antigüedad excedida
              </label>
            </div>
          )}
        </div>
      </div>

      <div className="container-form">
        <div className="label-form">Pertenece a: </div>
        <div className="container-list-Wgroups">
          <Select
            styles={{
              multiValueLabel: (base) => ({
                ...base,
                backgroundColor: "#00D4E2",
                color: "white",
                borderRadius: "none",
                fontSize: "1rem",
              }),
              multiValueRemove: (base) => ({
                ...base,
                display: "none",
              }),
              dropdownIndicator: (base) => ({
                ...base,
                display: "none",
              }),
              indicatorsContainer: (base) => ({
                ...base,
                display: "none",
              }),
              menuList: (base) => ({
                ...base,
                maxHeight: "20vh",
                overflowY: "auto",
              }),
            }}
            isMulti
            menuIsOpen={false}
            isSearchable={false}
            placeholder=""
            value={
              groups &&
              groups.length > 0 &&
              groups.map(function (item) {
                return { value: item._id, label: item.name };
              })
            }
            disabled
          />
        </div>
      </div>

      <div className="container-form">
        <div className="label-form">Asignación de grupos a comprobantes: </div>
        <div className="container-checkbox">
          <Select
            styles={{
              multiValueLabel: (base) => ({
                ...base,
                backgroundColor: "#00D4E2",
                color: "white",
                borderRadius: "none",
                fontSize: "1rem",
              }),
              multiValueRemove: (base) => ({
                ...base,
                backgroundColor: "#00D4E2",
                color: "white",
                borderRadius: "none",
                fontSize: "1rem",
              }),
              menuList: (base) => ({
                ...base,
                maxHeight: "15vh",
                overflowY: "auto",
              }),
            }}
            isMulti
            options={
              listGroups &&
              listGroups.length > 0 &&
              listGroups.map(function (item) {
                return { value: item._id, label: item.name };
              })
            }
            placeholder=""
            value={
              selectedGroupOptions &&
              selectedGroupOptions.length > 0 &&
              selectedGroupOptions.map(function (item) {
                return { value: item._id, label: item.name };
              })
            }
            onChange={handleSelectGroupChange}
          />
        </div>
      </div>

      <div className="container-btn">
        <button className="btn-form" onClick={handlerGenerar}>
          {tituloBoton}
        </button>
      </div>
      <div className="container-btn">
        <button className="btn-cancel-form" onClick={minimizar}>
          Cancelar
        </button>
      </div>
    </div>
  );
}

export default FormUser;